import { render, staticRenderFns } from "./AddLoadFAB.vue?vue&type=template&id=6e51aa12&"
import script from "./AddLoadFAB.vue?vue&type=script&lang=js&"
export * from "./AddLoadFAB.vue?vue&type=script&lang=js&"
import style0 from "./AddLoadFAB.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports